import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {authorizedLink} from 'utils'
import StyleSheet from 'styles'
import Typography from '@material-ui/core/Typography'
import LinkedInR from 'img/linkedin-Logo-2C-21px-R.png'

export class Teams extends Component {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  render = () =>
    <div className={[this.props.className, styles.container].filter(s => s).join(' ')} style={{marginBottom: 50}}>
      {this.props.dealSheet.teamMembers && this.props.dealSheet.teamMembers.map(member =>
        <div key={member.id}>
          {(member.photo) ?
            <img className={styles.photo} src={authorizedLink(member.photoUrls.small)} alt=""/>
            :
            <div className={styles('photo', 'noPhoto')}>(No Photo)</div>
          }
          <Typography variant="body1">{member.name}</Typography>
          <Typography>{member.title}</Typography>
          {member.url &&
            <Typography>
              <a href={member.url} target='blank'>
                <img alt={this.props.label} src={LinkedInR}/>
              </a>
            </Typography>
          }
        </div>
      )}
    </div>
}

const styles = StyleSheet({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    '&  > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '25%',
      minWidth: 240,
      boxSizing: 'border-box',
      padding: [0, 10, 20],
      textAlign: 'center',
    }
  },
  photo: {
    width: 200,
    height: 200,
    borderRadius: 100,
    boxSizing: 'border-box',
    border: '8px solid #e8e8e8',
    marginBottom: 5
  },
  noPhoto: {
    backgroundColor: '#1B3044',
    textAlign: 'center',
    paddingTop: 90,
    color: '#FFF',
    fontWeight: 500,
  }
})

export default Teams